{
  "en": {
    "aiFeedback": {
      "confirm": {
        "deleteFeedback": {
          "text": "This action cannot be undone. The feedback and all associated results will be deleted.",
          "title": "Delete feedback?"
        },
        "deleteResult": {
          "text": "This action cannot be undone. The result and its associated feedback will be permanently deleted.",
          "title": "Delete result?"
        }
      },
      "criteria": {
        "contentAccuracy": "Content Accuracy",
        "spellingAndGrammar": "Spelling and Grammar",
        "structureAndOrganization": "Structure and Organization"
      },
      "deprecationAlert": {
        "title": "This tool is hidden by default",
        "description": "It can be enabled at school level if required.",
        "learnMoreLink": "Learn more"
      },
      "unlockedAlert": {
        "title": "This tool is unlocked for your school",
        "description": "It is no longer being developed, but remains usable for your school.",
        "learnMoreLink": "Learn more"
      },
      "defaults": {
        "name": "New assessment"
      },
      "emptyState": {
        "heading": "No assessments yet",
        "text": "Create a new assessment to get started."
      },
      "flash": {
        "feedbackResultUpdated": "Feedback updated",
        "feedbackUpdated": "Criteria updated",
        "textExtractionSuccess": "Text extraction successful"
      },
      "headings": {
        "feedback": "Evaluation Draft",
        "form": "Specify criteria",
        "goodToKnow": "Good to know",
        "input": "Original text",
        "text": "Enter text"
      },
      "hints": {
        "dropFileImage": "Simply drag and drop an image with text content or",
        "dropFilePdf": "Drag PDF here or",
        "experimental": "The grading assistant tool provides <strong>AI-generated grading suggestions</strong> for student work based on specific assignments, model answers, and criteria provided by educators. Understanding the <strong>recommended guidelines and limitations of AI</strong> is crucial for the responsible use and interpretation of these grading suggestions. <a href='https://app.fobizz.com/en/help/articles/255-ai-guidelines' target='_blank'>Learn more</a>",
        "fileLimit": "max {size}MB, {types}",
        "imageRecognitionInProgress": "Image recognition in progress...",
        "pdfRecognitionInProgress": "Text extraction in progress..."
      },
      "info": {
        "result": {
          "heading": "Good to know:",
          "text": "The AI's answers are to be understood as <strong>suggestions</strong>.\nThey can never replace a well-founded didactic assessment of\nstudent performance."
        }
      },
      "infoMessages": {
        "criteria": "Define clear criteria for the AI to generate feedback. The more detailed you formulate the criteria, the more precise the feedback will be."
      },
      "labels": {
        "addCriteria": "Add criteria",
        "assignment": "Assignment",
        "criteria": "Evaluation criteria",
        "input": "Original text",
        "inputMethod": "Input method",
        "name": "Abbreviation or code (no full name)",
        "solution": "Sample solution or scope"
      },
      "links": {
        "evaluateText": "Evaluate text",
        "new": "New Assessment",
        "pastAssessments": "Past Assessments",
        "useFile": "Use text from image",
        "usePdf": "Use text from PDF",
        "useText": "Insert original text"
      },
      "modals": {
        "confirm": {
          "helpLink": "https://app.fobizz.com/en/help/articles/255-ai-guidelines",
          "text": "The grading assistant tool offers AI-generated <strong>grading suggestions</strong> for students' work based on specific assignments, sample answers, and criteria provided by educators. Understanding the <strong>recommended guidelines and limitations of AI</strong> is critical to the responsible use and interpretation of these grading suggestions.",
          "title": "Notes on using the Grading Assistant tool"
        }
      },
      "paragraphs": {
        "create": "Save valuable time assessing your students' work with automated grading suggestions based on your own criteria and assignments.",
        "goodToKnow": "The answers of the AI are to be understood as <strong>suggestions</strong>. They can never replace a well-founded didactic assessment of student performance."
      },
      "placeholders": {
        "assignment": "Write a short essay about the main causes and historical events of the French Revolution.",
        "input": "Enter text here...",
        "name": "4c-17",
        "solution": "Expectation:\nThe spelling, word formation and sentence structure are grammatically correct. Content and function words, complex expressions and technical terms are used appropriately.\n\nThe topic is developed in a manner appropriate to the question and contains correct figures, data and facts about the topic.\n\nThe text reveals an overall idea appropriate to the topic, is structured sensibly and shows a coherent internal and external structure."
      },
      "sampleText": "Dude! The French Revoluttion was this gnarly time from 1789 to 1799. The peeps were totally over all these noubles and the king, who were just kicking back while everyone else was starving. So they was like, 'That's it, man!' and they axed the king and the noblez. That was the end for the monarchy and the start of the first republic in France. But it wasn't all chill, was a ton of bloodshet, especially during the so-called 'Reign of Terror'. But when all's said and done, this revolution shook up the world and spread vibez like liberty, equality and brotherhood. Totally lit, right?"
    }
  }
}
